<template>
  <RelatorioSalesOrderView />
</template>

<script>
import RelatorioSalesOrderView from "@/views/relatorioSalesOrder/RelatorioSalesOrderView.vue";

export default {
  name: "RelatorioComercialSalesOrderView",
  components: {
    RelatorioSalesOrderView
  }
};
</script>
